import React from 'react';

const FIELD_INPUT: React.CSSProperties = {
  width: '100%',
  fontFamily: 'inherit',
  fontSize: 14,
  padding: '10px 12px',
  border: '1px solid var(--line)',
  borderRadius: 8,
  background: 'var(--card)',
  color: 'var(--text)',
};

/**
 * List editor — one input per item with remove, plus "Add item". The
 * stack convention for list-shaped content (bullet lists, feature lists):
 * never a single textarea with one-item-per-line.
 */
export default function ListEditor({
  items,
  onChange,
  addLabel = 'Add item',
}: {
  items: string[];
  onChange: (next: string[]) => void;
  addLabel?: string;
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {items.map((item, i) => (
        <div key={i} style={{ display: 'flex', gap: 6, alignItems: 'flex-start' }}>
          <textarea
            value={item}
            rows={Math.max(1, Math.ceil(item.length / 38))}
            onChange={(e) => {
              const next = [...items];
              next[i] = e.target.value;
              onChange(next);
            }}
            style={{
              ...FIELD_INPUT,
              padding: '7px 10px',
              fontSize: 13.5,
              lineHeight: 1.45,
              resize: 'none',
              minHeight: 34,
            }}
          />
          <button
            type="button"
            onClick={() => onChange(items.filter((_, idx) => idx !== i))}
            aria-label={`Remove item ${i + 1}`}
            title="Remove"
            style={{
              background: 'transparent', border: '1px solid var(--line)',
              borderRadius: 6, width: 28, height: 32, flex: '0 0 auto',
              color: 'var(--text-muted)', cursor: 'pointer', fontSize: 15, lineHeight: 1,
            }}
          >
            ×
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={() => onChange([...items, ''])}
        style={{
          alignSelf: 'flex-start',
          background: 'transparent', border: 'none', padding: '2px 0',
          color: 'var(--teal)', fontSize: 12.5, fontWeight: 600, cursor: 'pointer',
        }}
      >
        + {addLabel}
      </button>
    </div>
  );
}
